import { fhirClient } from "src/App";

export const getDevices = async () => {
  const query = `Device`;
  const result = await fhirClient.search(query);
  return result;
};

export const getDevicesByIds = async (ids: string[]) => {
  const query = `Device?_id=${ids.join(',')}`;
  const result = await fhirClient.search(query);
  return result;
};

export const getDeviceRequestsByPatient = async (patientId: string) => {
  const query = `DeviceRequest?patient=${patientId}`;
  const result = await fhirClient.search(query);
  return result;
};

export const getDeviceRequestsByServiceRequest = async (patientId: string) => {
  const query = `DeviceRequest?based-on=${patientId}`;
  const result = await fhirClient.search(query);
  return result;
};

export const getDeviceRequests = async () => {
  const query = `DeviceRequest`;
  const result = await fhirClient.search(query);
  return result;
};
